import axios from "axios";

async function getDataWelcoming() {
  const apiURL = "https://api-ekata.ekata.id/api/hero";

  return await axios
    .get(apiURL)
    .then((response) => {
      const res = response.data.data;
      return res;
    })
}

export { getDataWelcoming };
